import type { ButtonProps } from '@elfsight/widget-ui';
import { Button } from '@elfsight/widget-ui';
import { useTranslation } from 'react-i18next';
import { getSourceMetaValue } from '../../../constants';
import { usePost } from '../Post';
import { usePostSettings } from '../utils';

const FOLLOW_BUTTON_STYLES: ButtonProps = {
  mode: 'outline',
  borderRadius: 100,
  verticalPadding: 7,
  horizontalPadding: 9,
  lineHeight: 1.09,
  overlayOpacityOnHover: 0,
  font: {
    fontSize: 11,
    fontWeight: 'bold'
  }
};

export function FollowButton() {
  const { t } = useTranslation();
  const {
    followButtonLink,
    source: { type: platform }
  } = usePost();
  const { followButtonColor } = usePostSettings();

  const { followButtonText } = getSourceMetaValue(platform);

  if (!followButtonLink || !followButtonText) return null;

  return (
    <Button
      {...FOLLOW_BUTTON_STYLES}
      text={t(followButtonText)}
      color={followButtonColor}
      onClick={() => window.open(followButtonLink, '_blank')}
    />
  );
}
